import {
  DatabaseCreateInterface,
  DatabaseInterface,
  DatabaseRepositoryInterface, DatabaseUserCreateInterface, DatabaseUserEditInterface, DatabaseUserInterface,
  MigrationBatchInterface,
} from '@/services/Database/interfaces';
import { AxiosInstance } from 'axios';

export default class DatabaseRepository implements DatabaseRepositoryInterface {
  constructor(
    private readonly axios: AxiosInstance,
  ) {
  }

  public async createDatabase(data: DatabaseCreateInterface): Promise<DatabaseInterface> {
    const response = await this.axios.post('/database/databases', data);

    return response.data;
  }

  public async deleteDatabase(databaseId: number): Promise<void> {
    await this.axios.delete(`/database/databases/${databaseId}`);
  }

  public async getDatabaseById(databaseId: number): Promise<DatabaseInterface> {
    const response = await this.axios.get(`/database/databases/${databaseId}`);

    return response.data;
  }

  public async getDatabases(page?: number, search?: string, websiteIds?: number[], itemsPerPage?: number): Promise<[DatabaseInterface[], number]> {
    const params: any = {};
    let url = `/database/databases`;

    if (page) {
      params.page = page;
    }
    if (search) {
      params.search = search;
    }
    if (websiteIds) {
      params.websiteIds = websiteIds;
    }
    if (itemsPerPage && itemsPerPage > 0) {
      params.itemsPerPage = itemsPerPage;
    }

    const response = await this.axios.get(url, { params: params });

    return response.data;
  }

  public async getByWebsiteId(websiteId: number): Promise<DatabaseInterface[]> {
    const response = await this.axios.get(`/database/websites/${websiteId}`);

    return response.data;
  }

  public async getUsers(page: number, search?: string, itemsPerPage?: number): Promise<[DatabaseUserInterface[], number]> {
    const params = new URLSearchParams();
    params.set('page', String(page));
    if (itemsPerPage && itemsPerPage > 0) {
      params.set('itemsPerPage', String(itemsPerPage));
    }
    if (search) {
      params.set('search', search);
    }
    const response = await this.axios.get(`/database/users?${params.toString()}`);

    return response.data;
  }

  public async getAllDatabases(): Promise<DatabaseInterface[]> {
    const response = await this.axios.get('/database/databases');

    return response.data[0];
  }

  public async createUser(data: DatabaseUserCreateInterface): Promise<DatabaseUserInterface> {
    const response = await this.axios.post('/database/users', data);

    return response.data;
  }

  public async deleteUser(userId: number): Promise<void> {
    await this.axios.delete(`/database/users/${userId}`);
  }

  public async getUserById(userId: number): Promise<DatabaseUserInterface> {
    const response = await this.axios.get(`/database/users/${userId}`);

    return response.data;
  }

  public async editUser(userId: number, data: DatabaseUserEditInterface): Promise<void> {
    await this.axios.patch(`/database/users/${userId}`, data);
  }

  public async deleteDatabaseLog(id: number): Promise<void> {
    await this.axios.delete(`/database/databases/logs/${id}`);
  }

  public async deleteUserLog(id: number): Promise<void> {
    await this.axios.delete(`/database/users/logs/${id}`);
  }

  public async syncDatabaseSize(id: number): Promise<void> {
    await this.axios.patch(`/database/databases/${id}/size`);
  }

  public async syncGroupDatabases(groupId: number): Promise<void> {
    await this.axios.patch(`/database/groups/${groupId}/databases`);
  }

  public async getUserPlainPassword(id: number): Promise<string> {
    const response = await this.axios.get(`/database/users/${id}/hash`, {
      responseType: 'text',
    });

    return response.data;
  }

  public async getAllMigrationBatches(): Promise<MigrationBatchInterface[]> {
    const response = await this.axios.get(`/database/migrations/batches`);

    return response.data;
  }

  public async getMigrationBatchById(id: number): Promise<MigrationBatchInterface> {
    const response = await this.axios.get(`/database/migrations/batches/${id}`);

    return response.data;
  }

  public async deleteMigrationBatch(id: number): Promise<void> {
    await this.axios.delete(`/database/migrations/batches/${id}`);
  }
}
